export function rgba2hex(rgba) {
  const data = rgba.trim().match(/rgba\((\d+),(\d+),(\d+),(\d+)\)/);

  let r = parseInt(data[1], 10).toString(16);
  let g = parseInt(data[2], 10).toString(16);
  let b = parseInt(data[3], 10).toString(16);
  let a = parseInt(data[4], 10).toString(16);

  if (r.length === 1) r = `0${r}`;
  if (g.length === 1) g = `0${g}`;
  if (b.length === 1) b = `0${b}`;
  if (a.length === 1) a = `0${a}`;

  return `#${r}${g}${b}${a}`;
}

export function hex2rgba(hex) {
  // eslint-disable-next-line no-param-reassign
  hex = hex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const a = parseInt(hex.substring(6, 8), 16);

  return `rgba(${r},${g},${b},${a})`;
}
